import { ViewLegend } from '@ardoq/view-legend';
import { HeightOffset } from 'views/viewLegend/useViewLegendSubscription';
import { BubbleChartViewLegendProps } from '@ardoq/bubble-chart';
import { ViewLegendContainer, ViewLegendContainerProps } from '@ardoq/graph';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs/operators';
import { i18nLocale$ } from 'streams/i18nLocale$';
import type { WithI18nLocale } from '@ardoq/i18n';
import { getViewLegendLabels } from 'viewLegend/getViewLegendLabels';

const ZOOM_CONTROLS_HEIGHT = 36;
export const ZoomableViewLegendContainer = (
  props: ViewLegendContainerProps
) => (
  <ViewLegendContainer
    {...props}
    style={{ paddingTop: ZOOM_CONTROLS_HEIGHT }}
  />
);

const BubbleChartViewLegendInner = ({
  isLegendActive,
  componentTypes,
  activeConditionalFormatting,
  additionalRows,
  activeDiffMode,
  i18nLocale,
}: BubbleChartViewLegendProps & WithI18nLocale) => {
  return (
    <HeightOffset>
      {heightOffset => (
        <ZoomableViewLegendContainer
          visible={isLegendActive}
          heightOffset={heightOffset}
        >
          <ViewLegend
            componentTypes={componentTypes}
            activeConditionalFormatting={activeConditionalFormatting}
            additionalRows={additionalRows}
            activeDiffMode={activeDiffMode}
            labels={getViewLegendLabels(i18nLocale)}
          />
        </ZoomableViewLegendContainer>
      )}
    </HeightOffset>
  );
};

const i18nLocaleProps$ = i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })));

const BubbleChartViewLegend = connect(
  BubbleChartViewLegendInner,
  i18nLocaleProps$
);

export { BubbleChartViewLegend };
